module.exports = __webpack_public_path__ + "img/wx.181ff232.png";